import { useMutation, useQuery, useQueryClient } from 'react-query';
import {
  getMenuStock,
  getMenuStockDetail,
  updateMenuStock,
  getMenuStockTemplate,
  updateMenuStockTemplate,
  errorHandler
} from 'apis';
import { modalMethod } from 'components';

export const useGetMenuStock = (serviceDate: string) => {
  return useQuery(['getMenuStock', serviceDate], () => getMenuStock(serviceDate));
};

export const useUpdateMenuStock = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['updateMenuStock'],
    mutationFn: (params: any) => updateMenuStock(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['getMenuStock']);
      modalMethod.info('수량저장이 완료되었습니다.');
    }
  });
};

export const useGetMenuStockDetail = (menuId: string, params: any) => {
  return useQuery(['getMenuStockDetail', menuId, params], () => getMenuStockDetail(menuId, params), {
    enabled: !!menuId
  });
};

export const useGetMenuStockTemplate = () => {
  return useQuery(['getMenuStockTemplate'], () => getMenuStockTemplate());
};

export const useUpdateMenuStockTemplate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['updateMenuStockTemplate'],
    mutationFn: (params: any) => updateMenuStockTemplate(params),
    onSuccess: () => {
      queryClient.invalidateQueries(['getMenuStockTemplate']);
    },
    onError: (error) => {
      errorHandler(error);
    }
  });
};
